__webpack_require__.p = "/graphing-gains-from-trade/";